import axios from "axios";

export default class Mobility {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;

  }

  /*  ROUTES,STOPS,PLATFORMS  */
  async getLists(queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v2.0/booking/catalogs/list`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async uploadFile(queries) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v2.0/booking/catalogs`,
        data: queries
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async validate(query){
    try {
        const response = await axios({
            method: "post",
            url:`${this.API_LINK}/v2.0/booking/catalogs/validate`,
            data:query
        });
        return response.data;
    }catch(error){
        throw error;
    }
  }

  async getSchedule(query){
    try{
      const response = await axios({
        method:"post",
        url:`${this.API_LINK}/v2.0/booking/shifts`,
        data:query
      });
      return response.data;

    }
    catch(error){
       throw error
    }

  }

  async Planning(query){
    try{

      const response = await axios({
        method:"post",
        url:`${this.API_LINK}/v2.0/booking/planning`,
        data:query
      });
      return response.data;

    }
    catch(error){
      throw error
    }

  }


  async StopsEdit(query){
    try{

      const response = await axios({
        method:"put",
        url:`${this.API_LINK}/v2.0/booking/catalogs`,
        data:query
      });
      return response.data;

    }
    catch(error){
      throw error
    }

  }

  async StopsNew(query){
    try{

      const response = await axios({
        method:"POST",
        url:`${this.API_LINK}/v2.0/booking/catalogs/item`,
        data:query
      });
      return response.data;

    }
    catch(error){
      throw error
    }

  }

  async Cancellation(query){
    try{

      const response = await axios({
        method:"POST",
        url:`${this.API_LINK}/v2.0/booking/planning/cancellation`,
        data:query
      });
      return response.data;

    }
    catch(error){
      throw error
    }

  }

  async postNotif(notif) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/plant/notification/`,
        data: notif
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async GETsettings() {
    try {
      const response = await axios({
        method: "get",
        url: `${this.API_LINK}/v2.0/booking/planning/cancellation/settings/`
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async Createsettings(Set) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v2.0/booking/planning/cancellation/settings/`,
        data: Set
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async PUTsettings(Set) {
    try {
      const response = await axios({
        method: "put",
        url: `${this.API_LINK}/v2.0/booking/planning/cancellation/settings/`,
        data: Set
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }


  async ValPlanning(Set) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v2.0/booking/planning/`,
        data: Set
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  async ValPlatform(Set) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v2.0/booking/planning/`,
        data: Set
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

  //Bokking 0.2
  async getRoutes(data) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v2.0/booking/reservations`,
        data:data
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }
  async updateRoute(data,id) {
    try {
      const response = await axios({
        method: "put",
        url: `${this.API_LINK}/v2.0/booking/reservations/${id}`,
        data:data
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }

   async sendFile(data) {
    try {
      const response = await axios({
        method: "post",
        url: `${this.API_LINK}/v2.0/booking/reservations/upload`,
        data:data
      });
      return response;
    } catch (error) {
      throw error.response;
    }
  }


}
